export const customerMetricsResourceType = 'customer_metrics';
export const customerMetricsResourcePath = '/me/customer/metrics';
